/* Shared schema primitives used across multiple form schemas. */
import { z } from 'zod';

/* Entity reference shape stored in form state (transformer strips to { id } on save) */
export const entityRefSchema = z
  .object({ id: z.string(), name: z.string().nullish() })
  .nullish();
